import * as XLSX from 'xlsx';

export function exportToExcel<T>(data: T[], name: string) {
	const excelData = data.map(item => ({ ...item }));
	const workbook = XLSX.utils.book_new();

	const columnCount = Object.keys(excelData[0] || {});

	const wscols = [];
	for (let i = 0; i < columnCount.length; i++) {
		wscols.push({ wch: columnCount[i].length + 10 });
	}

	const worksheet = XLSX.utils.json_to_sheet(excelData);
	worksheet['!cols'] = wscols;

	XLSX.utils.book_append_sheet(workbook, worksheet, 'Enterprise Projects');

	const currentDate = new Date().toISOString().split('T')[0];
	const filename = `${name}_${currentDate}.xlsx`;
	XLSX.writeFile(workbook, filename);
}
